$(document).ready(function () {
  function activateTabBasedOnCollection() {
    var currentURL = window.location.href;
    var currentCollection = currentURL.split("/collections/")[1];
    if (currentCollection) {
      var tabToActivate = $('.tabs-inner a[href*="' + currentCollection + '"]');
      if (tabToActivate.length) {
        $(".tab").removeClass("active selected");
        tabToActivate.addClass("active selected");
        var sel = tabToActivate.attr("data-toggle-target");
        $(".tab-content").removeClass("active").filter(sel).addClass("active");
      }
    }
  }

  activateTabBasedOnCollection();

  $(".tab").on("click", function (evt) {
    evt.preventDefault();
    var sel = this.getAttribute("data-toggle-target");

    $(".tab").removeClass("active selected");
    $(this).addClass("active selected");
    $(".tab-content").removeClass("active").filter(sel).addClass("active");

    var collectionHandle = $(this).attr("title-data");
    var newURL = window.location.origin + "/collections/" + collectionHandle;

    if (collectionHandle) {
      history.replaceState(null, null, newURL);
    }
  });

  var a = "{{ collection.handle }}";
  if (!window.location.href.includes("/collections/")) {
    $(".tabs-inner a").removeClass("active selected");
    if ($('.tabs-inner a[title-data="' + a + '"]').length) {
      $('.tabs-inner a[title-data="' + a + '"]').addClass("active selected");
      var checkClass = $('.tabs-inner a[title-data="' + a + '"]').attr(
        "data-toggle-target"
      );
      $(".tab-content").removeClass("active");
      $(checkClass).addClass("active");
    } else {
      $(".tabs-inner a").removeClass("active selected");
      $('.tabs-inner a[title-data="all-products"]').addClass("active selected");
      $(".tab-content").removeClass("active");
      $(".tab-content-1").addClass("active");
    }
  }
});
